import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux";
import logoBlack from "../../assets/tomo_logo_black.svg";
import { track } from "../../api/heap";
import { uriHasOAuthStateId } from "../../utilities/userInfo";
import * as actions from "../../state/actions";

const md5 = require("md5");

const performLogin = (
  { email, password },
  setLoading,
  setErrorMessage,
  push,
  user,
  hydrateStateWithToken,
  redirectUrl = "resumeapplication",
  onboardingV2,
) => {
  setLoading(true);
  setErrorMessage(null);

  if (!email || !password) {
    setLoading(false);
    setErrorMessage("You need to enter an email and password");
    return null;
  }

  axios
    .post(`${process.env.REACT_APP_BACKEND_URL}/resume`, {
      username: email,
      password: md5(password),
    })
    .then(async (response) => {
      if (response.data && response.data.decision)
        setErrorMessage(
          "You have already received a decision. Please check your email for details.",
        );
      else if (response.data && response.data.token) {
        setErrorMessage(null);
        track("ONBOARDING_LOGIN_STEP_SUCCESS");
        window.localStorage.setItem("jwt", response.data.token);

        const {
          valid,
          applicationStatus,
          applicationProgress,
          loginsRequired,
          finicityLoginsRequired,
          shouldShowHome,
        } = await hydrateStateWithToken({
          jwt: response.data.token,
          email,
        });

        const unlinkedAccountsDetected = (loginsRequired && loginsRequired.length) || (finicityLoginsRequired && Object.keys(finicityLoginsRequired || {}).length);
        if(unlinkedAccountsDetected && onboardingV2){
          push("/relink");
          return;
        }

        if (shouldShowHome) {
          push("/home");
          return;
        }
        if (applicationStatus == "approved") {
          if (process.env.REACT_APP_NODE_ENV !== "local")
            return window.location.replace("/dashboard");

          return window.alert("You've already signed up!");
        }
        if (!valid) {
          track("ONBOARDING_ERROR_LOGIN_STEP", {
            message: "successful_login_issue",
          });
          console.log(
            "This shouldn't happen. User logged in successfully but hydrateState returned false.",
          );
          // should return?
        }

        if (unlinkedAccountsDetected) push("/linkbank");
        else if (
          applicationProgress &&
          applicationProgress.documentUpload === true &&
          applicationProgress.lastCompletedStep >= 7
        )
          push("/verifyiddocs");
        else push(redirectUrl);
      }
    })
    .catch((error) => {
      track("ONBOARDING_ERROR_LOGIN_STEP", {
        message: "invalid_password",
      });
      setErrorMessage("Incorrect Password");
      console.log("Failed to Login: ", error);
    })
    .finally(() => {
      setLoading(false);
    });
};

const Login = ({
  history,
  user,
  hydrateStateWithToken,
  onboardingV2,
}) => {
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = () => {
    track("ONBOARDING_LOGIN_STEP_SUBMITTED");

    const redirectUrl = uriHasOAuthStateId() ?
      `linkbank${window.location.search}&oauth_login=true` :
      'resumeapplication';

    performLogin(
      { email, password },
      setLoading,
      setErrorMessage,
      history.push,
      user,
      hydrateStateWithToken,
      redirectUrl,
      onboardingV2,
    );
  };

  return (
    <div className="bg-gray-100 flex h-screen outerContainer w-screen">
      <div className="bg-white block border innerContainer max-w-sm mx-auto px-10 py-10 self-center shadow-lg rounded">
        <img src={logoBlack} className="mx-auto" />
        <div className="w-full my-3 p-2 text-center">
          Log in to {uriHasOAuthStateId() ? "continue linking your bank account" : "resume your application"}
        </div>
        <input
          type="text"
          data-hj-allow
          name="email"
          value={email}
          placeholder="Email"
          className="inputField w-full my-2 p-2 border border-gray-300 rounded bg-white text-lg outline-none form-control data-hj-allow"
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <input
          type="password"
          name="password"
          value={password}
          placeholder="Password"
          className="w-full my-2 p-2 border border-gray-300 rounded bg-white inputField text-lg outline-none"
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          onKeyUp={(e) => {
            const keyCode = e.keyCode || e.which;
            if (keyCode == "13") {
              handleSubmit();
              return false;
            }
          }}
        />
        <div className={errorMessage ? "text-red-600 p-2" : "hidden"}>
          {errorMessage}
        </div>
        <input
          type="button"
          name="button"
          onClick={() => handleSubmit()}
          value="Resume Application"
          className={`button w-full p-4 bg-green-primary text-white rounded-sm loginButton shadow-lg rounded mt-3 font-bold cursor-pointer outline-none hover:shadow-xl border-none",
            ${loading ? "disabled opacity-50 cursor-not-allowed" : ""}`}
        />
        <div className="w-full my-3 pt-5 text-center text-gray-500">
          Forgot your password?{" "}
          <a
            className="hover:underline"
            style={{ color: "#33334d" }}
            href="/dashboard#/passwordrecovery"
          >
            Click here
          </a>
        </div>
      </div>
    </div>
  );
};

export default connect(
  (state) => ({
    user: state.register.user,
    onboardingV2: state.application['configVersion'] === '2.0' ? true : false,
  }),
  actions,
)(withRouter(Login));
